/* eslint-disable max-lines-per-function */
import React from 'react';
import {Form, Input, Button, message} from 'lark';
import PropTypes from 'prop-types';
import ExplainHeader from '~/component/login/H5/ExplainHeader';
import ImgIcon from '~/component/ImgIcon';
import {HttpCode} from '~/service/constant';
import {
    sendSmsCodeService,
    resetPasswordService
} from '~/service/reset';
import './index.less';

const DELAY = 3000;
const ONE_SECONDS = 1000;
const WAIT_TIME = 59;
// const PHONE_REG = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
const PHONE_REG = /^1\d{10}$/;
// 匹配是否包含数字
const IS_HAVE_NUM = /[0-9]+/g;
// 匹配是否包含大写字母
const IS_HAVE_UPPERCASE = /[A-Z]+/g;
// 匹配是否包含小写字母
const IS_HAVE_LOWERCASE = /[a-z]+/g;
// 匹配是否包含特殊字符
const IS_HAVE_SPEC_CHAR = /[~!@#$%^&*()_+`\-={}|\\[\]\\<>?,./:;'"]+/g;
class ResetForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            submitDisable: false,
            waitTime: WAIT_TIME,
        };
    }

    /**
     * 验证码发送并校验字段
     */
    onVerifiedSubmit = () => {
        const {form: {validateFields}} = this.props;
        validateFields(['accountName', 'phone'], async (errors, values) => {
            if (errors) {
                return;
            }
            const {accountName, phone} = values;

            try {
                await sendSmsCodeService({accountName, phone});
                message.success('验证码已发送，请查收');
                this.setState({loading: true}, () => {
                    this.count();
                });
            }
            catch (error) {
                if (error.code === HttpCode.paramsError && error.msg) {
                    this.handleErrorMsg(error, values);
                }
            }
        });
    };

    // 校验必须包含四种或三种类型的字符串
    checkPassword = (inputValue = '') => {
        let flag = 0;
        const regs = [IS_HAVE_NUM, IS_HAVE_UPPERCASE, IS_HAVE_LOWERCASE, IS_HAVE_SPEC_CHAR];

        regs.forEach(item => {
            item.lastIndex = 0;
            if (item.test(inputValue)) {
                flag++;
            }
        });
        return flag >= 3;
    };

    /**
     * 校验密码格式
     * @param {*} values 表单value
     */
    checkPasswordVaild = values => {
        const passwordReg = /^[a-zA-Z0-9~!@#$%^&*()_+`\-={}|\\[\]\\<>?,./:;'"]+$/;
        const {form: {setFields}} = this.props;
        if (!this.checkPassword(values.newPassword)) {
            setFields({
                newPassword: {
                    value: values.newPassword,
                    errors: [new Error('请输入数字，大小写，特殊符号至少三种组合')]
                }
            });
            return true;
        }
        if (!passwordReg.test(values.newPassword)) {
            setFields({
                newPassword: {
                    value: values.newPassword,
                    errors: [new Error('密码格式不合规，请输入正确密码格式')]
                }
            });
            return true;
        }
        if (values.confirmPassword !== values.newPassword) {
            setFields({
                confirmPassword: {
                    value: values.confirmPassword,
                    errors: [new Error('确认密码和新密码不匹配')]
                }
            });
            return true;
        }
        return false;
    };

    handleSubmit = () => {
        const {form: {validateFields}} = this.props;
        validateFields(async (errors, values) => {
            if (errors) {
                return;
            }

            if (this.checkPasswordVaild(values)) {
                return;
            }

            try {
                await resetPasswordService({...values});
                this.setState({submitDisable: true});
                message.success('3s跳回登录页，请重新登录');
                setTimeout(() => {
                    this.setState({submitDisable: false});
                    location.href = `/cas/login${location.search}`;
                }, DELAY);
            }
            catch (error) {
                if (error.code === HttpCode.paramsError && error.msg) {
                    this.handleErrorMsg(error, values);
                }
            }
        });
    };

    /**
     * 错误提示统一处理
     * @param {*} error 接口返回错误信息
     * @param {*} values 表单value值
     */
    handleErrorMsg = (error, values) => {
        const {form: {setFields}} = this.props;
        const errorMsg = error.msg;
        const errorFields = {};
        Object.keys(errorMsg).forEach(item => {
            errorFields[item] = {
                value: values[item],
                errors: errorMsg[item] ? [new Error(errorMsg[item])] : null
            };
        });
        setFields(errorFields);
    };

    /**
     * 倒计时
     */
    count = () => {
        let {waitTime} = this.state;
        const timer = setInterval(() => {
            this.setState({waitTime: (waitTime--)}, () => {
                if (waitTime <= -1) {
                    clearInterval(timer);
                    this.setState({loading: false, waitTime: WAIT_TIME});
                }
            });
        }, ONE_SECONDS);
    };

    render() {
        const {form: {getFieldDecorator}} = this.props;
        const {waitTime, loading, submitDisable} = this.state;
        return (
            <div className="h5-reset-form-wrapper">
                <ExplainHeader>
                    <span>重置密码</span>
                </ExplainHeader>
                <div className="h5-reset-form">
                    <Form.Item>
                        {
                            getFieldDecorator('accountName', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正确邮箱前缀',
                                    },
                                    {
                                        pattern: /^\S+$/,
                                        message: '不允许出现空格'
                                    }
                                ]
                            })(<Input
                                prefix={<ImgIcon type="mail" />}
                                placeholder="请输入邮箱前缀" autoComplete="off"
                            />)
                        }
                    </Form.Item>
                    <Form.Item>
                        {
                            getFieldDecorator('phone', {
                                rules: [
                                    {
                                        pattern: PHONE_REG,
                                        message: '请输入正确手机号'
                                    },
                                    {
                                        required: true,
                                        message: '请输入正确手机号',
                                    }
                                ]
                            })(<Input
                                prefix={<ImgIcon type="phone" />}
                                maxLength={11} placeholder="请输入手机号" autoComplete="off"
                            />)
                        }
                    </Form.Item>
                    <Form.Item>
                        {
                            getFieldDecorator('smsCode', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正确验证码',
                                    },
                                    {
                                        pattern: /^[0-9]*$/,
                                        message: '只能输入6位数字'
                                    }
                                ]
                            })(<Input
                                prefix={<ImgIcon type="code" />}
                                placeholder="请输入六位验证码"
                                class="valid-input"
                                autoComplete="off"
                                maxLength={6}
                                suffix={(
                                    <Button
                                        class={loading ? 'disable-valid-btn' : 'valid-btn'}
                                        onClick={this.onVerifiedSubmit}
                                        disabled={loading}
                                    >
                                        {loading ? `重新发送(${waitTime}s)` : '发送验证码'}
                                    </Button>
                                )}
                            />)
                        }
                    </Form.Item>
                    <Form.Item>
                        {
                            getFieldDecorator('newPassword', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正确密码',
                                    },
                                    {
                                        min: 8,
                                        message: '密码长度不能小于8'
                                    }
                                ]
                            })(<Input.Password
                                prefix={<ImgIcon type="lock" />}
                                placeholder="请输入数字，大小写，特殊符号至少三种组合"
                            />)
                        }
                    </Form.Item>
                    <Form.Item>
                        {
                            getFieldDecorator('confirmPassword', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正确密码',
                                    },
                                    {
                                        min: 8,
                                        message: '密码长度不能小于8'
                                    }
                                ]
                            })(<Input.Password
                                prefix={<ImgIcon type="lock" />}
                                autoComplete="off" placeholder="请再次输入新密码"
                            />)
                        }
                    </Form.Item>
                    <Button
                        class="confirm-button"
                        disabled={submitDisable}
                        onClick={this.handleSubmit}
                    >
                        确认
                    </Button>
                </div>
            </div>
        );
    }
}

ResetForm.propTypes = {
    form: PropTypes.shape({
        getFieldDecorator: PropTypes.func.isRequired,
        validateFields: PropTypes.func.isRequired,
        setFields: PropTypes.func.isRequired,
        getFieldValue: PropTypes.func.isRequired
    }).isRequired,
};
export default Form.create({})(ResetForm);
